import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import SignatureLoader from "../../common/SignatureLoader";
import {
  startBackgroundAssetLoading,
  waitForPriorityAssetsOrDeadline,
} from "../../common/page-readiness";

type InitialPageProps = {
  redirectTo?: string;
  onDone?: () => void;
};

const MINIMUM_LOADER_TIME_MS = 5000;
const SIGNATURE_LOGO_CYCLE_MS = 4000;
const CYCLE_ALIGNED_LOADER_TIME_MS =
  Math.ceil(MINIMUM_LOADER_TIME_MS / SIGNATURE_LOGO_CYCLE_MS) *
  SIGNATURE_LOGO_CYCLE_MS;

const InitialPage = ({ redirectTo = "/login", onDone }: InitialPageProps) => {
  const navigate = useNavigate();

  useEffect(() => {
    window.scroll(0, 0);

    let isMounted = true;
    let minimumLoaderTimeout: number | undefined;
    const priorityAssetsReadyOrDeadline = waitForPriorityAssetsOrDeadline();
    void startBackgroundAssetLoading();
    const minimumLoaderDuration = new Promise<void>((resolve) => {
      minimumLoaderTimeout = window.setTimeout(
        resolve,
        CYCLE_ALIGNED_LOADER_TIME_MS
      );
    });

    void Promise.all([minimumLoaderDuration, priorityAssetsReadyOrDeadline]).then(
      () => {
        if (!isMounted) return;
        onDone?.();
        navigate(redirectTo, { replace: true });
      }
    );

    return () => {
      isMounted = false;
      if (minimumLoaderTimeout !== undefined) {
        window.clearTimeout(minimumLoaderTimeout);
      }
    };
  }, []);

  return <SignatureLoader />;
};

export default InitialPage;
